export default __webpack_public_path__ + "static/media/viber.f078fdc1.png";